import * as types from 'src/store/mutation-types'
import i18n from 'src/i18n/i18n'

export default ({ app, store }) => {
  app.i18n = i18n

  store.commit(types.SET_LOCALE, i18n.locale)
}
